import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { obtenerCategorias, guardarCategoria, eliminarCategoria } from '../../services/categoriasServicio';

// --- LISTA DE ICONOS ---
const AVAILABLE_ICONS = [
    'hamburger', 'pizza-slice', 'hotdog', 'drumstick-bite', 'utensils',
    'th-large', 'leaf', 'carrot', 'apple-alt', 'fish', 'ice-cream',
    'birthday-cake', 'cookie', 'coffee', 'mug-hot', 'glass-cheers',
    'beer', 'wine-glass-alt', 'pepper-hot', 'cheese', 'bread-slice',
    'shopping-cart', 'tag'
];

// --- COMPONENTE: RENDER DE ICONO ---
const IconRenderer = ({ iconId, size = 20, color = '#333' }) => {
    const iconClass = iconId ? `fas fa-${iconId}` : 'fas fa-question-circle';
    return <i className={iconClass} style={{ color: iconId ? color : '#adb5bd', fontSize: `${size}px` }}></i>;
};

// --- COMPONENTE: SELECTOR DE ICONOS ---
const IconSelector = ({ selectedIconId, onIconSelect }) => (
    <div className="form-group mb-0">
        <label className="text-uppercase small font-weight-bold text-muted mb-3 d-block" style={{ letterSpacing: '1px' }}>
            Ícono Visual
        </label>
        <div className="icon-grid p-3 border rounded-lg bg-light">
            {AVAILABLE_ICONS.map(iconId => (
                <div
                    key={iconId}
                    onClick={() => onIconSelect(iconId)}
                    className={`icon-item ${selectedIconId === iconId ? 'active' : ''}`}
                >
                    <i className={`fas fa-${iconId}`}></i>
                </div>
            ))}
        </div>
        <style jsx>{`
            .icon-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(42px, 1fr));
                gap: 8px;
                max-height: 200px;
                overflow-y: auto;
            }
            .icon-item {
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                border-radius: 8px;
                color: #6c757d;
                background: white;
                transition: all 0.2s ease;
                border: 2px solid transparent;
                box-shadow: 0 2px 4px rgba(0,0,0,0.02);
            }
            .icon-item:hover {
                color: #007bff;
                background: #f8f9fa;
                transform: translateY(-2px);
            }
            .icon-item.active {
                background-color: #007bff;
                border-color: #0056b3;
                color: white;
                box-shadow: 0 4px 8px rgba(0,123,255,0.3);
            }
        `}</style>
    </div>
);

// --- COMPONENTE: MODAL DE FORMULARIO ---
const CategoryFormModal = ({ isVisible, onClose, onSave, categoryToEdit }) => {
    // CAMBIO 1: Se cambiaron los flags iniciales
    const [category, setCategory] = useState({ nombre: '', icono_id: null, mostrar_web: 1, mostrar_tpv: 1 });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // CAMBIO 2: Actualizar estado al editar
        if (isVisible) setCategory(categoryToEdit || { nombre: '', icono_id: null, mostrar_web: 1, mostrar_tpv: 1 });
    }, [categoryToEdit, isVisible]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!category.nombre) return toast.warning("Debes asignar un nombre");
        setIsLoading(true);
        try {
            await guardarCategoria(category);
            onSave();
        } catch (err) { toast.error("Error al procesar"); }
        finally { setIsLoading(false); }
    };

    if (!isVisible) return null;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content border-0 shadow-2xl rounded-xl overflow-hidden">
                    <div className="modal-header bg-white border-0 pt-4 px-4">
                        <h5 className="font-weight-bold m-0">{categoryToEdit ? 'Editar Categoría' : 'Nueva Categoría'}</h5>
                        <button className="close" onClick={onClose}>&times;</button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body p-4">
                            <div className="row">
                                <div className="col-md-6 border-right">
                                    <div className="form-group mb-4">
                                        <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Nombre Categoría</label>
                                        <input 
                                            type="text" className="form-control form-control-lg border-light bg-light" 
                                            value={category.nombre} onChange={(e) => setCategory({...category, nombre: e.target.value})}
                                            placeholder="Ej. Hamburguesas Gourmet"
                                        />
                                    </div>
                                    
                                    {/* CAMBIO 3: Los dos switches de TPV y WEB */}
                                    <div className="bg-light p-3 rounded-lg">
                                        <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Visibilidad</label>
                                        
                                        <div className="custom-control custom-switch mb-2">
                                            <input 
                                                type="checkbox" className="custom-control-input" id="swWeb"
                                                checked={category.mostrar_web === 1} 
                                                onChange={(e) => setCategory({...category, mostrar_web: e.target.checked ? 1 : 0})}
                                            />
                                            <label className="custom-control-label font-weight-bold text-dark" htmlFor="swWeb">
                                                <i className="fas fa-globe mr-1 text-primary"></i> Mostrar en Web
                                            </label>
                                        </div>

                                        <div className="custom-control custom-switch">
                                            <input 
                                                type="checkbox" className="custom-control-input" id="swTpv"
                                                checked={category.mostrar_tpv === 1} 
                                                onChange={(e) => setCategory({...category, mostrar_tpv: e.target.checked ? 1 : 0})}
                                            />
                                            <label className="custom-control-label font-weight-bold text-dark" htmlFor="swTpv">
                                                <i className="fas fa-desktop mr-1 text-primary"></i> Mostrar en TPV
                                            </label>
                                        </div>

                                        <small className="text-muted d-block mt-2">Los productos heredarán esta visibilidad.</small>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <IconSelector selectedIconId={category.icono_id} onIconSelect={(id) => setCategory({...category, icono_id: id})} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer border-0 bg-white p-4">
                            <button type="button" className="btn btn-link text-muted" onClick={onClose}>Cancelar</button>
                            <button type="submit" className="btn btn-primary btn-lg rounded-pill px-5 shadow-sm" disabled={isLoading}>
                                {isLoading ? 'Guardando...' : 'Guardar Categoría'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

// --- COMPONENTE PRINCIPAL ---
const AdministradorCategorias = () => {
    const [categories, setCategories] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [categoryToEdit, setCategoryToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => { cargarCategorias(); }, []);

    const cargarCategorias = async () => {
        try {
            const data = await obtenerCategorias();
            setCategories(data || []);
        } catch (err) { toast.error("Error de conexión"); }
    };

    const handleDelete = async (id, nombre) => {
        if (!window.confirm(`¿Eliminar "${nombre}"?`)) return;
        try {
            await eliminarCategoria(id);
            toast.success("Categoría eliminada");
            cargarCategorias();
        } catch (err) { toast.error("No se pudo eliminar"); }
    };

    const handleSave = () => {
        setIsModalOpen(false);
        setCategoryToEdit(null);
        toast.success("¡Excelente! Cambios guardados.");
        cargarCategorias();
    };

    const filtered = categories.filter(c => c.nombre.toLowerCase().includes(searchTerm.toLowerCase()));

      return (
        <div className="bg-light min-vh-100 py-5 px-3">
            <ToastContainer position="bottom-center" autoClose={2500} hideProgressBar />
            
            <div className="container" style={{ maxWidth: '1000px' }}>
                
                {/* CABECERA */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
                    <div>
                        <h1 className="h2 font-weight-bold text-dark mb-1">Administrar Categorías</h1>
                        <p className="text-muted">Organiza los productos de tu menú para tus clientes.</p>
                    </div>
                    <button className="btn btn-primary btn-lg rounded-pill shadow-lg px-4" onClick={() => { setCategoryToEdit(null); setIsModalOpen(true); }}>
                        <i className="fas fa-plus mr-2"></i> Nueva Categoría
                    </button>
                </div>

                {/* CARD PRINCIPAL */}
                <div className="card border-0 shadow-sm rounded-xl overflow-hidden">
                    
                    {/* BUSCADOR */}
                    <div className="card-header bg-white border-0 pt-4 px-4">
                        <div className="input-group bg-light rounded-pill px-3 py-1 border">
                            <div className="input-group-prepend border-0 bg-transparent">
                                <span className="input-group-text bg-transparent border-0 text-muted">
                                    <i className="fas fa-search"></i>
                                </span>
                            </div>
                            <input 
                                type="text" className="form-control bg-transparent border-0" 
                                placeholder="Escribe para buscar..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* TABLA CON SCROLL */}
                    <div className="card-body p-0">
                        <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            <table className="table table-hover align-middle mb-0">
                                <thead className="bg-light sticky-top" style={{ zIndex: 10, boxShadow: '0 2px 2px -1px rgba(0,0,0,0.1)' }}>
                                    <tr>
                                        <th className="border-0 px-4 py-3 text-muted small text-uppercase" style={{width: '100px'}}>Ícono</th>
                                        <th className="border-0 py-3 text-muted small text-uppercase">Nombre</th>
                                        <th className="border-0 py-3 text-muted small text-uppercase">Visibilidad</th>
                                        <th className="border-0 px-4 py-3 text-right text-muted small text-uppercase">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.map(c => (
                                        <tr key={c.id}>
                                            <td className="px-4 py-3">
                                                <div className="bg-light rounded-lg d-flex align-items-center justify-content-center" style={{width: '45px', height: '45px'}}>
                                                    {/* CAMBIO 4: El icono brilla azul si está activo en CUALQUIERA de los dos lados */}
                                                    <IconRenderer iconId={c.icono_id} size={22} color={(c.mostrar_web || c.mostrar_tpv) ? '#007bff' : '#ccc'} />
                                                </div>
                                            </td>
                                            <td className="py-3 font-weight-bold text-dark">{c.nombre}</td>
                                            <td className="py-3">
                                                {/* CAMBIO 5: Se muestran los dos estados en la tabla */}
                                                <div className="d-flex flex-column" style={{gap: '5px'}}>
                                                    <span className={`badge px-2 py-1 rounded-pill ${c.mostrar_web ? 'badge-soft-success' : 'badge-soft-secondary'}`} style={{width: 'max-content'}}>
                                                        <i className="fas fa-globe mr-1"></i> Web: {c.mostrar_web ? 'Visible' : 'Oculto'}
                                                    </span>
                                                    <span className={`badge px-2 py-1 rounded-pill ${c.mostrar_tpv ? 'badge-soft-success' : 'badge-soft-secondary'}`} style={{width: 'max-content'}}>
                                                        <i className="fas fa-desktop mr-1"></i> TPV: {c.mostrar_tpv ? 'Visible' : 'Oculto'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 text-right">
                                                <button className="btn btn-icon btn-light rounded-circle mr-2" onClick={() => { setCategoryToEdit(c); setIsModalOpen(true); }}>
                                                    <i className="fas fa-pen text-primary"></i>
                                                </button>
                                                <button className="btn btn-icon btn-light rounded-circle" onClick={() => handleDelete(c.id, c.nombre)}>
                                                    <i className="fas fa-trash text-danger"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {filtered.length === 0 && (
                                <div className="text-center py-5">
                                    <img src="https://cdn-icons-png.flaticon.com/512/7486/7486744.png" alt="vacio" style={{width: '80px', opacity: 0.3}} />
                                    <p className="mt-3 text-muted">No encontramos resultados para tu búsqueda.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ESTILOS */}
            <style jsx>{`
                .rounded-xl { border-radius: 1.25rem !important; }
                .rounded-lg { border-radius: 0.75rem !important; }
                .badge-soft-success { background-color: #e6fcf5; color: #087f5b; }
                .badge-soft-secondary { background-color: #f1f3f5; color: #495057; }
                .btn-icon { width: 38px; height: 38px; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: none; }
                .btn-icon:hover { background-color: #e9ecef; }
                .table-hover tbody tr:hover { background-color: #fbfbfb; }
            `}</style>

            <CategoryFormModal 
                isVisible={isModalOpen} onClose={() => setIsModalOpen(false)} 
                onSave={handleSave} categoryToEdit={categoryToEdit} 
            />
        </div>
    );
};

export default AdministradorCategorias;